import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack } from '@chakra-ui/react';
import { AppDrawer } from '@client/components/misc/AppDrawer';
import { FulfillmentFields } from '@client/components/shop/FulfillmentFields';
import { ShopFormFields } from '@client/components/shop/ShopFormFields';
import { useShopForm } from '@client/components/shop/useShopForm';
import { FulfillmentType } from '@client/constants';
import { useApiClient } from '@client/hooks/useApiClient';
import { toastError } from '@client/toaster';
import { callApi } from '@client/utils/apiUtils';
import { isValidEmail } from '@heirloom/common/utils/validationUtils';
import { useRef, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
export const CreateShopDrawer = ({ isOpen, onClose, onSuccess, }) => {
    const apiClient = useApiClient();
    const { title, setTitle, titleError, setTitleError, classification, setClassification, classificationError, country, setCountry, location, setLocation, locationError, imagePreviewUrl, isUploadingImage, handleImageSelect, resolveImageUuid, validateSharedFields, } = useShopForm();
    const [fulfillmentType, setFulfillmentType] = useState(FulfillmentType.HEIRLOOM);
    const [ownerEmail, setOwnerEmail] = useState('');
    const [ownerEmailError, setOwnerEmailError] = useState(null);
    const [isConfirming, setIsConfirming] = useState(false);
    const titleFieldRef = useRef(null);
    const handleConfirm = () => {
        const sharedValid = validateSharedFields();
        let ownerValid = true;
        if (fulfillmentType === FulfillmentType.DIRECT) {
            if (!ownerEmail.trim()) {
                setOwnerEmailError('Owner email is required.');
                ownerValid = false;
            }
            else if (!isValidEmail(ownerEmail)) {
                setOwnerEmailError('Email format is invalid.');
                ownerValid = false;
            }
            else
                setOwnerEmailError(null);
        }
        else {
            setOwnerEmailError(null);
        }
        if (!sharedValid || !ownerValid)
            return;
        confirm();
    };
    const confirm = async () => {
        setIsConfirming(true);
        const result = await callApi(apiClient.admin.createShop({
            body: {
                title,
                classification,
                location,
                countryCode: country,
                directFulfillment: fulfillmentType === FulfillmentType.DIRECT,
                ownerEmail: fulfillmentType === FulfillmentType.DIRECT
                    ? ownerEmail
                    : undefined,
                profileImageUuid: resolveImageUuid(),
            },
        }));
        setIsConfirming(false);
        if (result.status === 409) {
            setTitleError('A shop with this name already exists.');
            titleFieldRef.current?.scrollIntoView({
                behavior: 'smooth',
            });
            return;
        }
        if (result.error !== null) {
            toastError('Failed to create shop. Please try again.');
            return;
        }
        onSuccess(result.data);
    };
    const confirmButton = (_jsxs(Button, { size: "xl", width: "100%", onClick: handleConfirm, disabled: isConfirming || isUploadingImage, loading: isConfirming || isUploadingImage, children: [_jsx(FaCheckCircle, {}), "Confirm"] }));
    return (_jsx(AppDrawer, { title: "New Shop", isOpen: isOpen, onClose: onClose, footer: confirmButton, children: _jsxs(Stack, { gap: 3, children: [_jsx(ShopFormFields, { title: title, onTitleChange: setTitle, titleError: titleError, titleFieldRef: titleFieldRef, classification: classification, onClassificationChange: setClassification, classificationError: classificationError, country: country, onCountryChange: setCountry, location: location, onLocationChange: setLocation, locationError: locationError, imagePreviewUrl: imagePreviewUrl, isUploadingImage: isUploadingImage, onImageSelect: handleImageSelect, disabled: isConfirming }), _jsx(FulfillmentFields, { fulfillmentType: fulfillmentType, onFulfillmentTypeChange: setFulfillmentType, ownerEmail: ownerEmail, onOwnerEmailChange: setOwnerEmail, ownerEmailError: ownerEmailError, disabled: isConfirming })] }) }));
};
